import { Container, Content, Image } from './CampaignCta.styles';
import { PageSubtitleShort } from '@zoopla-eng/zds-components/headings';

type Props = {
    className?: string;
    image: string;
    title: string;
    body: string;
    children?: React.ReactNode;
};

export const CampaignCta = ({
    className,
    image,
    title,
    body,
    children,
}: Props) => {
    return (
        <Container className={className}>
            <Image src={image} alt="" />
            <Content>
                <PageSubtitleShort>{title}</PageSubtitleShort>
                <p>{body}</p>
                {children}
            </Content>
        </Container>
    );
};
